import { useEffect, useContext } from "react";
import MenuToggle from "./MenuToggle/MenuToggle";
import useStore from "@/hooks/useStore";
import { useAnimate } from "framer-motion";
import { NavLink } from "react-router-dom";
import { context } from "@/Layout";
import useUtils from "@/hooks/useUtils";
import { DESKTOP } from "@/utils/appConstants";
import NavMenuRevamp from "./NavMenuRevamp/NavMenuRevamp";

const useMenuAnimation = (isOpen) => {
  const [scope, animate] = useAnimate();
  const { device } = useUtils();
  const desktop = device === DESKTOP;

  useEffect(() => {
    const menuAnimations =
      (isOpen && !desktop) || desktop
        ? [
            [
              ".menu-container",
              { top: "0%", pointerEvents: "auto", opacity: 1 },
              { duration: 0.3, ease: [0.08, 0.65, 0.53, 0.96] },
            ],
            [
              ".menu-item",
              { opacity: 1, pointerEvents: "auto", transform: "translateY(0%)" },
              { delay: 0.1, duration: 0.2 },
            ],
          ]
        : [
            [
              ".menu-item",
              { opacity: 0, pointerEvents: "none", transform: "translateY(-10px)" },
              { duration: 0.2 },
            ],
            [
              ".menu-container",
              { top: "-100%", pointerEvents: "none", opacity: 0 },
              { duration: 0.3, ease: [0.08, 0.65, 0.53, 0.96] },
            ],
          ];

    animate([
      [".hamburger-nav", { rotate: isOpen ? 45 : 0 }, { delay: 0.5, at: "<" }],
      [".line.top", { y: isOpen ? 8 : 0 }, { delay: 0.2, at: "<" }],
      [".line.middle", { opacity: isOpen ? 0 : 1 }, { delay: isOpen ? 0 : 0.2, at: "<" }],
      [".line.bottom", { y: isOpen ? -4 : 0, rotate: isOpen ? 90 : 0 }, { delay: 0.2, at: "<" }],
      ...menuAnimations,
    ]);
  }, [isOpen, device]);

  return scope;
};

const HeaderRevamp = () => {
  const { toggleIsOpened, isOpened } = useContext(context);
  const { acfOptions } = useStore();
  const siteOptions = acfOptions();
  const { site_logo: siteLogo } = siteOptions;
  const scope = useMenuAnimation(isOpened);
  const HEADER_H = 80;

  return (
    <div
      id="header_revamp"
      ref={scope}
      className={`sticky pointer-events-auto top-0 left-0 right-0 z-30 w-full flex justify-between mx-auto -mb-32 transition-all duration-200 ease-in-out lg:overflow-visible`}
    >
      <div
        aria-hidden
        className={`
          fixed inset-x-0 top-0 pointer-events-none
          bg-[#F6FCFF1A] backdrop-blur-[24px]
          transition-[height,opacity] duration-300 ease-out
        `}
        style={{
          height: isOpened ? "100vh" : `${HEADER_H}px`,
          opacity: 1,
          WebkitTransform: "translate3d(0,0,0)",
          transform: "translate3d(0,0,0)",
          willChange: "height",
        }}
      />
      <div className="main-nav relative container-revamp py-6 w-full flex flex-row justify-between transition-all duration-200 ease-in-out items-center lg:py-0 xl:static xl:px-0">
        {siteLogo && (
          <NavLink
            className="site-logo z-20 relative max-w-[76px] flex-[1_0_auto] opacity-100 transition-all duration-200 ease-in-out lg:mr-10 hover:opacity-75"
            onClick={() => isOpened && toggleIsOpened(false)}
            to="/"
          >
            <img alt="logo" className="h-full w-full" src={`${siteLogo?.url || null}`} />
          </NavLink>
        )}

        <NavMenuRevamp />

        <MenuToggle />
      </div>
    </div>
  );
};

export default HeaderRevamp;
